import * as types from 'modules/statistics/actionTypes';
import type { AuditInFilesSummary, FetchAuditInFilesSummarySuccessAction } from 'modules/statistics/types/auditInFiles';
import { createReducer } from 'utils/ReduxUtils';

const initialState: AuditInFilesSummary = {
  createdFiles: 0,
  filesWithRequiredAudits: 0,
  requiredAudits: 0,
  requiredCompletedAudits: 0,
  averageRequiredAudits: 0,
  averageCompletedRequiredAudits: 0,
  additionalAudits: 0,
  additionalCompletedAudits: 0,
  averageAdditionalAudits: 0,
  averageCompletedAdditionalAudits: 0,
};

const toFiniteNumber = (value: unknown): number => (typeof value === 'number' && Number.isFinite(value) ? value : 0);

const sanitize = (summary: AuditInFilesSummary): AuditInFilesSummary =>
  (Object.keys(initialState) as Array<keyof AuditInFilesSummary>).reduce((acc, key) => {
    acc[key] = toFiniteNumber(summary[key]);
    return acc;
  }, {} as AuditInFilesSummary);

const updateAllData = (_: AuditInFilesSummary, { payload }: FetchAuditInFilesSummarySuccessAction) => sanitize(payload);

export default createReducer(initialState, {
  [types.FETCH_AUDIT_IN_FILES_SUMMARY_SUCCESS]: updateAllData,
});
